module.exports = __webpack_public_path__ + "static/media/LambdaSchool.9ec7e58e.jpg";